import React, { useState } from 'react';
import './style.css';

const items = [
  {
    pic: require('../../assets/photosofjuniorkalamwithcircle/1.png'),
    name: 'Tanav Raj P',
    label: 'Discovered a Main Belt Asteroid',
  },
  {
    pic: require('../../assets/photosofjuniorkalamwithcircle/2.png'),
    name: 'Vihaan Singh Bisht',
    label: 'Won the International Space Olympiad held between 10+ Countries',
  },

  {
    pic: require('../../assets/photosofjuniorkalamwithcircle/3.png'),
    name: 'Yatharth Kushwaha',
    label: 'Built a Sounding Rocket that went 100ft up in the sky',
  },
  {
    pic: require('../../assets/photosofjuniorkalamwithcircle/4.png'),
    name: 'Rafan Aman Shariff',
    label: 'Built a 6-inch Newtonian Telescope',
  },
  {
    pic: require('../../assets/photosofjuniorkalamwithcircle/5.png'),
    name: 'Ekannsh Anand',
    label: 'Started their own company of live space games',
  },
];

const mobItem = [1, 2, 3];
const firstMonth = 'https://rzp.io/l/NASASpaceTour';
const thirdMonth = 'https://rzp.io/l/3NewMth';
const sixthMonth = 'https://rzp.io/l/6NewMth';

export const Kalam = ({ pricingRef }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [mobIndex, setMobIndex] = useState(1);
  const [touchPosition, setTouchPosition] = useState(null);
  const [touchPositionMob, setTouchPositionMob] = useState(null);

  const handleClick = (link) => {
    window.open(link);
  };

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = items.length - 1;
    } else if (newIndex >= items.length) {
      newIndex = 0;
    }

    setActiveIndex(newIndex);
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      if (mobIndex >= 3) {
        setMobIndex(1);
      } else setMobIndex((prev) => prev + 1);
    }

    if (diff < -5) {
      if (mobIndex <= 1) {
        setMobIndex(1);
      } else setMobIndex((prev) => prev - 1);
    }

    setTouchPosition(null);
  };

  const handleTouchStartMob = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPositionMob(touchDown);
  };

  const handleTouchMoveMob = (e) => {
    const touchDown = touchPositionMob;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      updateIndex(activeIndex + 1);
    }

    if (diff < -5) {
      updateIndex(activeIndex - 1);
    }

    setTouchPositionMob(null);
  };

  const renderMob = () => {
    if (mobIndex === 2) {
      return (
        <>
          <div
            className='pricing-mobile'
            style={{ left: '60%', height: '70%', opacity: '0' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span className='register-btn'>Register</span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')}) center center / cover`,
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className='pricing-mobile'
            style={{ left: '50%', height: '80%', opacity: '1', zIndex: '2' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Space
                  <br />
                  Creator{' '}
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>3 Month</span>
                <span className='discount'>Save 47%</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Create & Present projects to Space Scientists{' '}
              </div>
              <ul>
                <li>Collaborate & Create a Science Project</li>
                <li>Create & Own your Mars Base</li>
                <li>Gain high-school level science knowledge</li>
                <li>Build your Own Rockets</li>
              </ul>
            </div>
            <div className='line-div'>
              <span className='line-label'>Most Popular</span>
              <hr />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 2,699</span>
                <span className='price-strike'>₹ 5,100</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(thirdMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/spacecomm.png')}) center center / contain no-repeat`,
                      }}
                    ></div>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/sittingastro.png')}) center center / cover`,
                      }}
                    ></div>
                  </div>
                  <span>Science Communicator || Space Creator </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className='pricing-mobile'
            style={{ left: '45%', opacity: '0.7', height: '75%' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span className='register-btn'>Register Now</span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    if (mobIndex === 1) {
      return (
        <>
          <div
            className='pricing-mobile'
            style={{ left: '60%', height: '70%', opacity: '0' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span className='register-btn'>Register Now</span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className='pricing-mobile'
            style={{ left: '55%', height: '75%', opacity: '0.7' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(firstMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
          <div className='pricing-mobile'>
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(firstMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    if (mobIndex === 3) {
      return (
        <>
          <div
            className='pricing-mobile'
            style={{ left: '50%', height: '80%', opacity: '1', zIndex: '2' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Space
                  <br />
                  Internship
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>6 Month</span>
                <span className='discount'>Save 61%</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                15-day internships at top space research bodies
              </div>
              <ul>
                <li>Work under a real Space Scientist</li>
                <li>Apply your knowledge and make unique discoveries</li>
                <li>Lead your Space Exploration Team</li>
                <li>Your Own Metaverse to Learn & Create</li>
              </ul>
            </div>
            <div className='line-div'>
              <span
                className='line-label'
                style={{ backgroundColor: '#DD8965' }}
              >
                Best Value
              </span>
              <hr />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 3,855</span>
                <span className='price-strike'>₹ 10,000</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(sixthMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/certiifedicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Certified Space Scientist & Young Space Leader</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className='pricing-mobile'
            style={{ left: '45%', height: '75%', opacity: '0.7' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span className='register-btn'>Register Now</span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className='pricing-mobile'
            style={{ left: '45%', opacity: '0', height: '75%' }}
          >
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span className='register-btn'>Register Now</span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <div className='wrapper-kalam'>
      <div className='metro-rocks-mob'></div>
      <div className='space-expedition'></div>
      <div className='heading-div'>
        <span>
          Junior <span className='color'>Kalams</span>
        </span>
      </div>
      <div className='big-carousel'>
        <div
          className='prev-btn'
          onClick={() => updateIndex(activeIndex - 1)}
        ></div>
        <div
          className='big-carousel-wrapper'
          onTouchStart={handleTouchStartMob}
          onTouchMove={handleTouchMoveMob}
        >
          {items.map((item, index) => (
            <div
              className='carousel-item'
              key={index}
              style={{
                transform: `translateX(-${activeIndex * 100}%)`,
                opacity: activeIndex === index ? 1 : 0,
              }}
            >
              <div
                className='kalam-pic'
                style={{
                  background: `url(${item.pic})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='kalam-desc'>
                <span className='kalam-indicator'>
                  {'(' + (index + 1) + '/' + items.length + ')'}
                </span>
                <span className='kalam-name'>{item.name}</span>
                <span className='kalam-label'>Proud Alumni of Kalam Labs</span>
                <span className='kalam-work'>{item.label}</span>
              </div>
            </div>
          ))}
        </div>
        <div
          className='next-btn'
          onClick={() => updateIndex(activeIndex + 1)}
        ></div>
      </div>
      <div className='pagination'>
        {items.map((item, index) => {
          if (index === activeIndex) {
            return <div key={index} className='active-dot'></div>;
          } else return <div key={index} className='dot'></div>;
        })}
      </div>
      <div className='pricing-div'>
        <span className='pricing-heading' ref={pricingRef}>
          Curriculum & Pricing
        </span>
        <div
          className='pricing-wrapper'
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
        >
          {renderMob()}
          <div className='pricing'>
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Introduction in <br />
                  Space Sciences
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>1 Month</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Fun-activities to build foundational knowledge.
              </div>
              <ul>
                <li>Learn the Power of Rockets</li>
                <li>Secrets of Alien Life</li>
                <li>The Science behind the Planets</li>
              </ul>
            </div>
            <div className='line-div'>
              <hr style={{ width: '100%' }} />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 1,699</span>
                <span className='price-strike'>₹ 1,699</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(firstMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/introicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Introduction to Astronomy</span>
                </div>
              </div>
            </div>
          </div>
          <div className='pricing'>
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Space
                  <br />
                  Creator{' '}
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>3 Month</span>
                <span className='discount'>Save 47%</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                Create & Present projects to Space Scientists{' '}
              </div>
              <ul>
                <li>Collaborate & Create a Science Project</li>
                <li>Create & Own your Mars Base</li>
                <li>Gain high-school level science knowledge</li>
                <li>Build your Own Rockets</li>
              </ul>
            </div>
            <div className='line-div'>
              <span className='line-label'>Most Popular</span>
              <hr />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 2,699</span>
                <span className='price-strike'>₹ 5,100</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(thirdMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/spacecomm.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/sittingastro.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Science Communicator || Space Creator </span>
                </div>
              </div>
            </div>
          </div>
          <div className='pricing'>
            <div className='pricing-heading-div'>
              <div className='pricing-text-div'>
                <span className='pricing-text'>
                  Space
                  <br />
                  Internship
                </span>
              </div>
              <div className='duration-div'>
                <span className='duration-text'>6 Month</span>
                <span className='discount'>Save 61%</span>
              </div>
            </div>
            <div className='pricing-info'>
              <span className='pricing-info-heading'>Curriculum Includes</span>
              <div className='pricing-info-desc'>
                15-day internships at top space research bodies
              </div>
              <ul>
                <li>Work under a real Space Scientist</li>
                <li>Apply your knowledge and make unique discoveries</li>
                <li>Lead your Space Exploration Team</li>
                <li>Your Own Metaverse to Learn & Create</li>
              </ul>
            </div>
            <div className='line-div'>
              <span
                className='line-label'
                style={{ backgroundColor: '#DD8965' }}
              >
                Best Value
              </span>
              <hr />
            </div>
            <div className='pricing-details'>
              <div className='pricing-value'>
                <span className='price'>₹ 3,855</span>
                <span className='price-strike'>₹ 10,000</span>
              </div>
              <span
                className='register-btn'
                onClick={() => handleClick(sixthMonth)}
              >
                Register Now
              </span>
              <div className='pricing-tags'>
                <div className='pricing-ach'>
                  <div className='pricing-star'></div>
                  <span>Achievements</span>
                </div>
                <div className='pricing-res'>
                  <div className='badge-container'>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/certiifedicon.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                    <div
                      className='badge'
                      style={{
                        background: `url(${require('../../assets/astroleader.png')})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                  </div>
                  <span>Certified Space Scientist & Young Space Leader</span>
                </div>
              </div>
            </div>
          </div>{' '}
        </div>
      </div>
      <div className='mob-pagination'>
        {mobItem.map((item, index) => {
          if (index + 1 === mobIndex) {
            return (
              <div
                className='dot'
                key={index}
                style={{ background: '#81E8E2' }}
              ></div>
            );
          } else {
            return <div className='dot' key={index}></div>;
          }
        })}
      </div>
    </div>
  );
};
